exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wall-navigation .col[data-v-2bd1e9ce]{padding:0!important}#wall-navigation .btn.btn-clear.active i.fas[data-v-2bd1e9ce]{color:#00f}", ""]);

// exports
